import type { OptLogVolumeActionsTypes } from '~/shared/types/api';

/** API / wire `type` strings → display types used in the UI and `OptLogVolumeActions.type`. */
export const apiWireTypeToDisplayType: Record<string, OptLogVolumeActionsTypes> = {
  modify: 'Modify',
  Modify: 'Modify',
  redistribute: 'Change Performance Tier',
  Redistribute: 'Change Performance Tier',
  'Tier Change': 'Change Performance Tier',
};

export const knownOptLogDisplayActionTypes = new Set<string>([
  'Growth',
  'Shrink',
  'Modify',
  'Change Performance Tier',
  'Activate Autoscaling',
  'Deactivate Autoscaling',
]);

export function wireTypeToOptLogDisplayType(raw: string): OptLogVolumeActionsTypes | undefined {
  const mapped = apiWireTypeToDisplayType[raw];
  if (mapped) {
    return mapped;
  }
  if (knownOptLogDisplayActionTypes.has(raw)) {
    return raw as OptLogVolumeActionsTypes;
  }
  return undefined;
}

/** Display types → API list/count `type` query param (when not 1:1). */
export function optLogDisplayTypeToApiWireType(displayType: OptLogVolumeActionsTypes): string {
  if (displayType === 'Change Performance Tier') {
    return 'Tier Change';
  }
  return displayType;
}

/** API `type` query param → UI action-type filter value (bookmarks, shared links). */
export const apiWireTypeToActionTypeFilterValue: Record<string, string> = {
  modify: 'Modify',
  Modify: 'Modify',
  redistribute: 'Change Performance Tier',
  Redistribute: 'Change Performance Tier',
  'Tier Change': 'Change Performance Tier',
};
